import { ajax, getLanguage } from '@/api/ajax';

export interface OpenArticleItemVo {
  articleId: number;
  articleUuid: string;
  title: string;
  summary: string;
  toped: 0 | 1;
  topTime: number | null;
  publishTime: number;
  requiredRead: 0 | 1;
  whetherRead: 0 | 1 | null;
}

export interface OpenArticlePage {
  current: number;
  size: number;
  total: number;
  records: OpenArticleItemVo[];
}

export interface ListArticlePageReq {
  secondChannelId: number;
  countryCode: string;
  current?: number;
  pageSize?: number;
  /** 当前语言码（后端要求 body 里也要带上），由 ajax 层的 languageProvider 自动填充 */
  language?: string;
}

export function listArticlePage(data: ListArticlePageReq) {
  return ajax<OpenArticlePage>({
    url: '/api/tis/web/sip/notice/listArticlePage',
    method: 'post',
    data: { language: getLanguage(), ...data }
  });
}
